<template>
    <div class="white-wrapper">
        <main class="contact">
            <div class="contact__wrapper">
                <div class="contact__big-title">
                    <span>İletişim</span>
                </div>
                <div class="contact__information">
                    <span class="contact__description">Bize aşağıda bulunan iletişim kanallarından ulaşabilir ya da formu doldurabilirsiniz.</span><br><br>
                    <div class="contact__information-phone">
                        <span><b>Finish</b></span><br>
                        <span><b>Santral Numarası:</b> 0(212) 326 9700</span><br><br>
                        <span><b>Tüketici Danışma Hattı:</b> 0850 297 7238</span>
                    </div>
                    <div class="contact__information-address">
                        <span><b>Merkez ofis:</b> Orta Mah. Demokrasi Cad. Benckiser Sit. No:92 Tuzla,İstanbul</span>
                        <br><br>
                        <span><b>Yönetim Ofisi:</b> Dikilitaş Mah. Hakkı Yeten Cad. Selenium Plaza 10 C Fulya, İstanbul</span>
                    </div>
                </div>
                <div class="contact__big-title">
                    <span>Form</span>
                </div>
                <div class="contact__form">
                    <div class="contact__form-item">
                        <label for="name" class="contact__form-item-title">Adınız - Soyadınız</label>
                        <input type="text" id="name" class="contact__form-item-input">
                    </div>
                    <div class="contact__form-item">
                        <label for="phone" class="contact__form-item-title">Telefon Numaranız: (Opsiyonel)</label>
                        <input type="text" id="phone" class="contact__form-item-input">
                    </div>
                    <div class="contact__form-item">
                        <label for="email" class="contact__form-item-title">Eposta Adresiniz: (Opsiyonel)</label>
                        <input type="text" id="email" class="contact__form-item-input">
                    </div>
                    <div class="contact__form-item">
                        <label for="message-title" class="contact__form-item-title">Mesaj Konusu:</label>
                        <input type="text" id="message-title" class="contact__form-item-input">
                    </div>
                    <div class="contact__form-item">
                        <label for="message" class="contact__form-item-title">Mesajınız:</label>
                        <textarea rows="20" cols="60" name="message" id="message" class="contact__form-item-textarea"></textarea>
                    </div>
                    <div class="contact__form-button">
                        <span>GÖNDER</span>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "Contact",
        mounted() {
            EventBus.$emit('menu-status', false);
            this.$store.commit('navigationStatus', 'subPage');
        }
    }
</script>

<style lang="scss">
    
    $base-width: 1140px;
    $icon-font: "Font Awesome 5 Free";


.white-wrapper {

    background-color: white;
    width: 100%;
}


.contact{
 min-height: calc(100vh - 121px);
        color: black;
    &__wrapper{
        width: 666px;
        margin: 50px auto;

    }

    &__big-title{
        font-size: 25px;
        font-weight: bold;
        color: black;
        text-align: center;
        margin-bottom: 30px;
    }
    &__description{
        font-size: 15px;
    }
    &__information-phone{
        margin-bottom: 70px;
    }
    &__information-address{
        margin-bottom: 80px;
    }

    &__form{
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    &__form-item{
        width: 426px;
        display: flex;
        flex-direction: column;
        margin-bottom: 21px;
    }

    &__form-item-title{
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 12px;
    }
    &__form-item-input{
        height: 51px;
        padding: 0 10px;
        border: solid 1px #979797;
        background-color: #f5f4f4;
    }
    &__form-item-textarea{
        padding: 10px 10px;
        border: solid 1px #979797;
        background-color: #f5f4f4;
    }
    &__form-button{
        border-radius: 28.5px;
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.22);
        background-image: linear-gradient(to top, #4a4a4a, #9b9b9b);
        height: 57px;
        display: flex;
        align-items: center;
        color: white;
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
        >span{
            padding: 20px 70px;
            
        }
        &__form-button:hover{
            
        }
    }
}

@media screen and (max-width: 600px) {
    .contact{
        margin: 50px auto;
        &__wrapper{
            width: 100%;
            padding: 0 20px;
            margin: 0 auto;
        }
        &__form-item{
            width: 100%;
        }
    }   
}

</style>